import { FavouriteCondition } from 'app/types-shared';
import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { FilterTypes, OptionTypes, ConditionValuesOperator, Filter } from 'app/components/filters/types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';
import { FilterDecimal } from 'app/components/filters/filters-panel/filter-types/filter-decimal/filter-decimal';
import { EditingValues } from 'app/components/filters/filters-panel/types';
import { getValue } from 'app/components/filters/filters-panel/filter-types/get-value';
import { createFavouriteCondition } from 'app/components/filters/filters-panel/conditions/create-conditions';
import { getConditionForOperator } from '../get-condition';

export const decimalNumberConfiguration = {
  [FilterTypes.DecimalNumber]: filterConfiguration(
    FilterDecimal,
    undefined,
    [customFilterFieldPostfix.decimalFrom, customFilterFieldPostfix.decimalTo]
  )
};

export const decimalNumberConditionMapper = (editingValues: EditingValues) => {
  return {
    [FilterTypes.DecimalNumber]: (filter: Filter) => {

      const { optionType, advancedField } = filter;

      if (!advancedField) {
        return [];
      }

      if (optionType === OptionTypes.NotSpecified) {

        const originalCondition = getConditionForOperator(filter.conditions, advancedField.valueOperator3);
        return [
          createFavouriteCondition(filter, [{
            id: 1,
            operator: advancedField.valueOperator3,
            dbFunction: advancedField.dbFunctionValue3
          }], originalCondition)
        ];
      }

      const originalRangeCondition = getConditionForOperator(filter.conditions, advancedField.valueOperator);
      const valueFrom = getValue(filter, editingValues, customFilterFieldPostfix.decimalFrom);
      const valueTo = getValue(filter, editingValues, customFilterFieldPostfix.decimalTo);
      const rangeOperator = valueFrom === '' || valueFrom === undefined ? ConditionValuesOperator.lessOrEqual : 
        valueTo === '' || valueTo === undefined ? ConditionValuesOperator.largerOrEqual : ConditionValuesOperator.between;
      const condition = (!!valueFrom || valueFrom === 0) || (!!valueTo || valueTo === 0) ?
         createFavouriteCondition(filter, [{
          id: 1,
          myValue: false,
          periodPredef: { v: 0 },
          operator: {v: rangeOperator},
          dbFunction: advancedField.dbFunctionValue,
          number: valueFrom === ''  || valueFrom === undefined ? valueTo : valueFrom,
          number2: valueFrom === '' || valueFrom === undefined ? '' : valueTo
        }], originalRangeCondition) : undefined;

      return [
        ...(!!condition ? [condition] : [])
      ];

    }
  };
};

export const decimalNumberOptionType = (condition: FavouriteCondition) => {

  if (condition.values && condition.values.some(v => v.operator && v.operator.v === ConditionValuesOperator.empty)) {
    return {
      [FilterTypes.DecimalNumber]: OptionTypes.NotSpecified
    };
  }

  return {
    [FilterTypes.DecimalNumber]: OptionTypes.SpecificNumbersOrRanges
  };
};
